export enum StorageKeys {
  USER_DATA = "USER_DATA",
}
export enum ScopeType {
  Site = 1,
  Business,
}
export type TransactionModel = "Credit" | "Debit";

export enum BulkVoucherStatus {
  Processing = 1,
  Generated = 2,
}

export enum VoucherType {
  Sales = 1,
  InStore = 3,
}
export enum ApprovalStatusType {
  AwaitingReview = -1,
  Pending = 0,
  Confirmed = 1,
  Declined = 2,
}
export enum TransactionStatusType {
  Pending = 0,
  Successful = 1,
  Failed = 2,
}
export enum TransactionType {
  WalletDirectTopup = 1,
  WalletDirectDebit = 2,
  WalletFunding = 3,
  VoucherPurchase = 4,
  AirtimePurchase = 5,
  BillsPayment = 6,
}
export enum RefundStatusType {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}
export enum WalletType {
  None = 0,
  CashWallet = 1,
  Paypal = 2,
  BankTransfer = 3,
  Voucher = 4,

  Paystack = 6,
  Crypto = 7,
  Rmt = 8,
  FlutterwaveKenya = 9,
  Kora = 10,
}
export enum VoucherOperationType {
  Activation = 1,
  Blacklist = 2,
  Transfer = 3,
  Deactivation = 4,
  Restore = 5,
  Merge = 6,
  Reactivation = 7,
  Redemption = 8,
  RedemptionReversal = 9,
  Release = 10,
  Replacement = 11,
  Cancel = 12,
  Split = 13,
  Swap = 14,
  Mergeitem = 15,
  Splititem = 16,
}
export enum VoucherStatusType {
  Pending = 0,
  FailedCreation = 1,
  Generated = 2,
  Active = 3,
  Deactivated = 4,
  Blacklisted = 5,
  Splited = 6,
  Merged = 7,
  Replaced = 8,
  Canceled = 9,
}
export enum MerchantApprovalType {
  Pending = 0,
  Accepted = 1,
  Declined = 2,
}
export const emptyOption = { text: "All", value: undefined };
export enum StorePersonnelType {
  Controller = 1,
  Personnel = 2,
}
export enum OrderStatusType {
  Checkedout = 1,
  Scheduled = 2,
  Delivered = 4,
  Canceled = 5,
  Processing = 6,
  Failed = 7,
  PartiallyDelivered = 8,
}
export enum DeliveryStatusType {
  Pending,
  Delivered,
  Failed,
  Generated,
  Canceled,
}
export enum DeliveryMediumType {
  Email = 1,
  HomeDelivery = 2,
  Pdf = 3,
}
